// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eS34","buttons":"styles_buttons__DVL0v"};